import {
	contentChildren,
	DestroyRef,
	Directive,
	effect,
	input,
	Input,
	output,
	Output,
	viewChildren,
} from '@angular/core'
import { StepValueDirective } from './step-value.directive.js'
import { MatStepper } from '@angular/material/stepper'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Directive({
	selector: '[lowgileStepperValue], [lowgileStepperValueChange]',
})
export class StepperDirective<T = any> {
	steps = contentChildren<StepValueDirective<T>>(StepValueDirective)
	lowgileStepperValue = input<T | undefined>(undefined)
	lowgileStepperValueChange = output<T>()

	constructor(
		private stepper: MatStepper,
		destroyRef: DestroyRef,
	) {
		effect(() => {
			const value = this.lowgileStepperValue()
			if (value !== undefined) {
				const index = this.steps()?.findIndex(
					(step) => step.getValue() === value,
				)
				if (index !== -1) {
					this.stepper.selectedIndex = index
				}
			}
		})

		this.stepper.selectionChange
			.pipe(takeUntilDestroyed(destroyRef))
			.subscribe((event) => {
				this.lowgileStepperValueChange.emit(
					this.getStepValue(event.selectedIndex),
				)
			})
	}

	getStepValue(index: number) {
		return this.steps()?.[index]?.getValue()
	}
}
